import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { PillSuggestion } from 'owa-search-service';
import { setSuggestionPills } from '../actions/internalActions';

export { ObservableMap, PillSuggestion };

export default mutator(setSuggestionPills, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).suggestionPills = actionMessage.suggestionPills;
});
